var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './EndSlotButton.module.css';
export const EndSlotButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-label': ariaLabel, 'data-testid': testId, disabled, Icon, onClick, }) => {
    return (
    // TODO TODO TODO-  https://lucidlink.atlassian.net/browse/LUCID-15888 - Use a Transparent Button component from DS
    _jsx("button", { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, "aria-label": ariaLabel, className: styles.EndSlotButton, "data-testid": testId, disabled: disabled, onClick: onClick, type: "button", children: _jsx(Icon, { size: "middle" }) }));
};
_react_refresh_temp_1 = EndSlotButton;
$RefreshReg$(_react_refresh_temp_1, "EndSlotButton");
